import { useEffect } from "react";
import useReaderStore from "../context/readerStore";

const DEFAULT_TITLE = "IGP Reader 3.0";

/**
 * Syncs the browser tab title with the loaded document name.
 * Falls back to the default product title when no document is open.
 */
export default function useDocumentTitle() {
  const documentName = useReaderStore((state) => state.documentName);

  useEffect(() => {
    const trimmedName = documentName?.trim();
    document.title = trimmedName
      ? `${trimmedName} · ${DEFAULT_TITLE}`
      : DEFAULT_TITLE;
  }, [documentName]);
}
